// ⚠️ GENERATED COPY — DO NOT EDIT.
// Source: shared/lib/lookupsKey.ts — edit there, then run: bash scripts/sync_shared_code.sh
// CI verifies these copies match the source (sync_shared_code.sh --check).
/**
 * makeLookupKeyFetcher — factory for the cached API-key fetchers used by the
 * address-autocomplete cores (addressComplete, googlePlaces).
 *
 * The app's lookups endpoint is bound in the per-app adapter (physician:
 * `/api/config/lookups`; patient: `/api/bridge/config/lookups`) — never
 * hardcoded here. Each adapter calls this factory once at module load, so the
 * closure's cached promise has the same once-per-session lifetime as the
 * module-level `_keyPromise` singleton it replaces.
 *
 * Failure semantics (behavioral invariant — do NOT add error surfacing):
 * ANY failure (non-ok response, network error, malformed body, missing key)
 * resolves to "" → the feature is silently OFF and the address fields stay
 * plain inputs. Failures are cached like successes (same as the original
 * singleton: one fetch per session, whatever the outcome).
 */

export function makeLookupKeyFetcher(endpoint: string, cfgKey: string): () => Promise<string> {
  let keyPromise: Promise<string> | null = null;
  return function getKey(): Promise<string> {
    if (!keyPromise) {
      keyPromise = fetch(endpoint)
        .then((r) => (r.ok ? r.json() : {}))
        .then((cfg: any) => (cfg && cfg[cfgKey]) || "")
        .catch(() => "");
    }
    return keyPromise;
  };
}
